export enum VIEW_TYPE {
    NEW_REQUESTS = 'NEW',
    RETURNED_REQUESTS = 'RETURNED',
    ASSIGNED_TO_ME_REQUESTS = 'ASSIGNED',
    INPROGRESS_REQUESTS = 'INPROGRESS',
    SECURITY_COORDINATOR_REQUESTS = 'SECURITYCOORDINATORREQUESTS',
    COMPLETED_REQUESTS = 'COMPLETED',
    EMPLOYEE_MANAGEMENT_REQUESTS = 'EMPLOYEEMANAGEMENTREQUESTS',
    COMPLETED_HISTORY_REQUESTS = 'COMPLETEDHISTORYREQUESTS',
    TECHNICAL_OPERATIONS_REQUESTS = 'TECHNICALOPERATIONSREQUESTS',
    CALL_RECORD = 'CALL_RECORD',
    DASHBOARD = 'DASHBOARD',
    CLIENTS = 'clients',
    REPORT = 'report',
    SHARED_REPORTS = 'shared_reports',
    CALL_RECORD_DASHBOARD = 'CALL_RECORD_DASHBOARD',
    E_SERVICE = 'SERVICE',
    CALL_CENTER_CLIENT_REQUEST = 'CALL_CENTER_CLIENT_REQUEST',
    E_SERVICE_HISTORY_FEILD = 'E_SERVICE_HISTORY_FEILD'
}
